module.exports = __webpack_public_path__ + "img/shipo-menu-barge-intelligent-system.3d40910d.svg";